import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginButton from "../../components/Elements/Buttons/LoginButton";
import Footer from "../../components/Elements/Footer";
import { Header } from "../../components/Elements/Header";
import { useAuth } from "../../providers/auth";
import { usePartnerData } from "../../providers/partnerData";

const LoginPage = () => {
  const navigate = useNavigate();
  const { partnerUrl } = usePartnerData();

  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      navigate(`/${partnerUrl}`);
    }
  }, [token]);

  return (
    <>
      <Header />
      <div id="wrapper" className="p-0">
        <div className="page-header flex-fill">
          <div className="shape"></div>
          <div className="container position-relative py-5">
            <div className="row justify-content-center gy-5 gx-lg-5">
              <div className="col-lg-5">
                <div className="card text-body bg-light p-3 p-md-5">
                  <h3 className="mb-1">Faça seu Login</h3>
                  <p className="mb-4 text-muted">
                    Informe seus dados de acesso.
                  </p>
                  <LoginButton className="btn-lg btn-success">
                    Entrar
                  </LoginButton>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="card text-body p-4 p-md-5 bg-light">
                  <h3 className="mb-1">Faça seu cadastro, é gratuito!</h3>
                  <p className="mb-4 text-muted">
                    Agende agora mesmo sua consulta.
                  </p>
                  <Link
                    to={`/${partnerUrl}/user`}
                    className="btn btn-lg btn-primary fw-semibold"
                  >
                    Cadastrar
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LoginPage;
